
























import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonCalendar, { CalendarEvent, EventColor } from '../../components/organisms/CommonCalendar.vue';
import { Session } from '../../utils/Session';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';
import { getTeacherSuffixInSession } from '../../utils/building_trans';
import { TimeGridView } from '@fullcalendar/timegrid';
import DaEventDetailDialog from './ui/DaEventDetailDialog.vue';
import { MessageDialog } from '../../utils/MessageDialog';

@Component({ components: { CommonCalendar, DaEventDetailDialog } })
export default class DaDashBoard extends Vue {
  private loading = false;
  private userId = '';
  private lessons: LessonDTO[] = [];
  private get title() {
    return `${Session.getSessionNickName()}さんの予約カレンダー`;
  }
  get calendarEvents(): CalendarEvent[] {
    let calendarEvents: CalendarEvent[] = [];
    calendarEvents = this.lessons.map((dto) => {
      const start = dto.lessons.start_dt?.toLocaleString() || '';
      const end = dto.lessons.end_dt?.toLocaleString() || '';
      const teacherName = dto.teacher?.nickname;
      const eventData: any = {};
      const lesson_id = dto.lessons.class_id;
      // 確定
      if (dto.lessons.reservation_state === LessonStates.COMMIT) {
        eventData.title = `${teacherName}${getTeacherSuffixInSession()}の予約確定(${lesson_id})`;
        eventData.color = EventColor.COMMITED;
        eventData.type = 'commited';
      }
      // 依頼
      if (dto.lessons.reservation_state === LessonStates.RESERVATION) {
        eventData.title = `${teacherName}${getTeacherSuffixInSession()}の予約承認待ち(${lesson_id})`;
        eventData.color = EventColor.RESERVATION_REQ;
        eventData.type = 'request';
      }

      // 確定
      if (dto.lessons.reservation_state === LessonStates.ALREADY) {
        eventData.title = `${teacherName}${getTeacherSuffixInSession()}の実施済(${lesson_id})`;
        eventData.color = EventColor.DONE;
        eventData.type = 'commited';
      }

      return {
        title: eventData.title,
        start: start,
        end: end,
        id: dto.lessons.class_id,
        backgroundColor: eventData.color,
        type: eventData.type,
      } as CalendarEvent;
    });
    return calendarEvents;
  }

  async eventClick(e: any) {
    const lesson_id = parseInt(e.event.id);
    const lesson = this.lessons.find((l) => l.lessons.class_id === lesson_id);
    if (!lesson) {
      await MessageDialog.systemError('レッスンID', 'ダッシュボード詳細表示時', lesson);
      return;
    }
    const dialog: DaEventDetailDialog = this.$refs['DaEventDetailDialog'] as DaEventDetailDialog;
    dialog.show(lesson);
  }

  handleDateClick(e: any) {
    console.log(e);
  }

  async deleteLesson(class_id: number) {
    const deletedLessonIndex = this.lessons.findIndex((l) => l.lessons.class_id === class_id);
    this.lessons.splice(deletedLessonIndex);
  }

  /**
   * 表示している領域が変更になった時
   */
  async datesRender(event: any, el: any) {
    const view: TimeGridView = event.view;
    const start = view.activeStart;
    const end = view.activeEnd;
    await this.loadData(start, end);
  }

  async loadData(from: Date, to: Date) {
    this.loading = true;

    const user = Session.get<UserAuthDTO>('USER');
    if (!user) return;
    this.userId = user.user_id!;

    const biz = new LessonsService();
    const respose = await biz.getCommitedLessonByTerm(this.userId, from.toLocaleString(), to.toLocaleString());
    this.lessons = respose.data;
    this.loading = false;
  }
}
